import React from 'react';
import { Link, Text } from '@chakra-ui/react';
import { FormData } from './SdgQuiz';
import { useResponsive } from '#core/SdgQuiz/utils';

type SkipSdgProps = {
  data: any;
  sdgNumber: number;

  updateFields: (fields: Partial<FormData>, reset: boolean) => void;
  handleNext: () => void;
};

export const SkipSdg = ({
  data,
  sdgNumber,
  updateFields,
  handleNext,
}: SkipSdgProps) => {
  const handleSkipSdg = () => {
    const updatedFields: any = {};

    Object.keys(data).forEach((key) => {
      if (!key.startsWith(`sdg${sdgNumber}`)) {
        updatedFields[key] = data[key];
      }
    });

    updateFields(updatedFields, true);

    handleNext();
  };

  const isMobileScreen = useResponsive();

  return (
    <Link
      mt={8}
      fontWeight="bold"
      fontSize={isMobileScreen ? 'sm' : 'md'}
      textDecoration="underline"
      onClick={handleSkipSdg}
    >
      <Text>Skip this SDG</Text>
    </Link>
  );
};
